import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = o((e, r) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: r,
    ...e,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3508",
              width: 4,
              height: 16,
              x: 6,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M7.97 3.94C6.88 3.94 6 3.06 6 1.97S6.88 0 7.97 0s1.97.88 1.97 1.97-.88 1.97-1.97 1.97m0-2.44a.47.47 0 1 0-.001.939.47.47 0 0 0 .001-.939M7.97 9.97C6.88 9.97 6 9.09 6 8s.88-1.97 1.97-1.97S9.94 6.91 9.94 8s-.88 1.97-1.97 1.97m0-2.44a.47.47 0 1 0-.001.939.47.47 0 0 0 .001-.939M7.97 16C6.88 16 6 15.12 6 14.03s.88-1.97 1.97-1.97 1.97.88 1.97 1.97S9.06 16 7.97 16m0-2.44a.47.47 0 1 0-.001.939.47.47 0 0 0 .001-.939"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3508)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyMoreIcon";
export {
  i as AgencyMoreIcon,
  i as default
};
//# sourceMappingURL=index.js.map
